import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppHttpService } from 'src/services/app-http/app-http.service';
import { ConfigService } from 'src/services/config/config.service';
import { SharedDataService } from 'src/services/shared-data/shared-data.service';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.page.html',
  styleUrls: ['./refund-policy.page.scss'],
})
export class RefundPolicyPage implements OnInit {


  constructor(
    public mdCtrl: ModalController,
    public shared: SharedDataService,
    public config: ConfigService,
    public appHttpService: AppHttpService,) {
    this.shared.currentOpenedModel = this;
  }
  ngOnInit() {
    if (this.shared.refundPolicy == "")
      this.getPageData()
  }
  getPageData() {
    let url = "pages/2"
    url += "?language_id=" + this.config.languageIdNumber
    this.appHttpService.getHttp(url).then((data: any) => {
      this.shared.refundPolicy = data.detail[0].description
    })
  }

  // For Modal Dismiss
  dismiss() {
    this.shared.currentOpenedModel = null;
    this.mdCtrl.dismiss();
  }

}
